// src/components/Footer.js
import React from "react";
import { useTranslation } from "../hooks/useTranslation";
import { Logo } from "./Logo";

export const Content = ({ children, className = "" }) => {
  const { t, getLocalizedPath } = useTranslation();

  return <section className={`content ${className}`}>{children}</section>;
};
